import React from "react";
import {
  StyleSheet,
  View,
  Image,
  TouchableOpacity,
  Text,
} from "react-native-web";
import { Colors, Fonts } from "../../../config";
import { useTranslation } from "react-i18next";
const SectionTitleView = (props) => {
  const { t } = useTranslation();
  const onViewAll = () => {
    if (props.onViewAll) {
      props.onViewAll();
    }
  };
  return (
    <View style={[styles.titleSection, props.style]}>
      <Text style={styles.title}>{props.title}</Text>
      {props.hasViewAll && (
        <TouchableOpacity onPress={onViewAll}>
          <Text style={styles.viewAllBtn}>{t("key_view_all")}</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch",
  },
  titleSection: {
    flexDirection: "row",
    alignSelf: "stretch",
    alignItems: "center",
    paddingHorizontal: 16,
    justifyContent: "space-between",
    marginBottom: 10,
  },
  title: {
    fontSize: 20,
    fontFamily: Fonts.primaryBold,
    color: Colors.white,
    textTransform: "uppercase",
  },
  viewAllBtn: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: Fonts.primaryBold,
    color: Colors.white,
  },
});

export default SectionTitleView;
